import {
  ImageBackground,
  StyleSheet,
  ScrollView,
  View,
  Platform,
  Linking,
} from "react-native";
import React, { useEffect, useState } from "react";
import { BoldTxt, H2, SmallTxt, Txt } from "../components/TextsComponents";
import { colors } from "../styles/GlobalStyle";
import DimensionsHook from "../hooks/DimensionsHook";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useDispatch, useSelector } from "react-redux";

import { resetUser, setUserData } from "../redux/Actions";
import { PrimaryButton } from "../components/Buttons";
import { useTranslation } from "react-i18next";
import Spinner from "../components/Spinner";
import axios from "axios";
import EulaModal from "../components/modals/EulaModal";
import CompanyLifeTimeCard from "./Plans/CompanyLifeTimeCard";
import CompanySubscriptionCard from "./Plans/CompanySubscriptionCard";
import CompanyTrialCard from "./Plans/CompanyTrialCard";

const PlansCompanies = ({ navigation }) => {
  const { t } = useTranslation();
  const { height, width, isDesktop } = DimensionsHook();
  const userData = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [subscriptions, setSubscriptions] = useState([]);
  const [lifetimeData, setLifetimeData] = useState({});
  const [showEula, setShowEula] = useState(true);
  const [userGift, setUserGift] = useState(null);

  const getCurrentUrl = async () => {
    const url = await Linking.getInitialURL();
    return url;
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      dispatch(setUserData());
      if (
        (userData.subscription && userData.subscription_status == "active") ||
        userData.lifetime_subscription
      ) {
        const currentUrl = await getCurrentUrl();
        if (currentUrl.includes("/gift")) {
          navigation.replace("GiftWeb");
        } else if (currentUrl.includes("/sponsor")) {
          navigation.replace("ParrainageWeb");
        } else {
          navigation.replace("TabNavigation");
        }
      }
      return clearInterval(interval);
    }, 1500);
  }, [userData]);

  const logoutHandler = async () => {
    await AsyncStorage.removeItem("access_token");
    dispatch(resetUser());

    navigation.reset({
      index: 0,
      routes: [{ name: "Loader" }],
    });
  };

  useEffect(() => {
    const giftUrl = process.env.GIFT_DATA;
    const url = process.env.SUBSCRIPTIONS_LIST + "-companies";
    setLoader(true);
    axios
      .get(`${giftUrl}?email=${userData.email}`)
      .then((res) => {
        if (res.data == null) {
          setUserGift(null);
        } else {
          setUserGift(res.data);
        }
        axios
          .get(url)
          .then((res) => {
            const subs = res.data.filter(
              (product) => product.lifetime == false
            );
            const lifetime = res.data.find(
              (product) => product.lifetime == true
            );
            setLoader(false);
            const arr = subs.filter((el) =>
              el.ios_iap.includes(userData.company_payment)
            );
            setSubscriptions(arr);
            setLifetimeData(lifetime);
          })
          .catch((err) => {
            navigation.replace("NoConnection");
          });
      })
      .catch((err) => {
        navigation.replace("NoConnection");
      });
  }, []);

  if (loader) {
    return (
      <View style={styles.container}>
        <ImageBackground
          source={require("../assets/background.png")}
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <Spinner size="large" />
        </ImageBackground>
      </View>
    );
  }
  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../assets/background.png")}
        style={{ flex: 1 }}
      >
        <ScrollView
          style={{ flex: 1 }}
          showsVerticalScrollIndicator={Platform.OS === "web"}
        >
          <View style={[styles.plansContainer, { minHeight: height }]}>
            <View style={styles.logoutContainer}>
              <PrimaryButton
                onPress={logoutHandler}
                style={{ flexDirection: "row", alignItems: "center" }}
              >
                <SmallTxt color={colors.white}>
                  {t("setting_screen.logout_button")}
                </SmallTxt>
              </PrimaryButton>
            </View>
            <View>
              <H2
                style={{
                  textAlign: "center",

                  marginTop: isDesktop ? 0 : 30,
                  marginHorizontal: 20,
                  fontSize: 28,
                  lineHeight: 34,
                }}
              >
                {t("plans.choose_plan")}
              </H2>
              {/** stripe break point to add code */}

              {Platform.OS != "ios" && width < 992 && (
                <Txt style={{ textAlign: "center", marginHorizontal: 15 }}>
                  {t("plans.code_text")}
                </Txt>
              )}
              {/** case is parrained show message */}
              {userData.parrained && (
                <Txt
                  style={{
                    textAlign: "center",
                    marginBottom: 15,
                    marginTop: 15,
                  }}
                >
                  <BoldTxt>
                    {userData.parrainedBy && userData.parrainedBy}{" "}
                  </BoldTxt>
                  {t("parrainage.text2")}
                </Txt>
              )}
            </View>

            {/** cards container */}
            <View style={styles.cardsContainer}>
              <CompanyTrialCard userGift={userGift} navigation={navigation} />

              {subscriptions.map((plan) => {
                return (
                  <CompanySubscriptionCard
                    navigation={navigation}
                    key={plan._id}
                    plan={plan}
                  />
                );
              })}
              <CompanyLifeTimeCard
                navigation={navigation}
                plan={lifetimeData}
              />
            </View>
            <View style={{ height: 60 }} />
          </View>
        </ScrollView>
        <EulaModal
          //  isOpen={showEula && Platform.OS != "web"}
          isOpen={false}
          setIsOpen={setShowEula}
        />
      </ImageBackground>
    </View>
  );
};

export default PlansCompanies;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.beige,
  },
  cardsContainer: {
    width: "95%",
    alignSelf: "center",
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginTop: 10,
  },
  logoutContainer: {
    alignSelf: "flex-end",
    paddingTop: 30,
    paddingRight: 30,
  },
});
